import { OlympusClient } from '@/OlympusClient'

import {
  type WebsiteResource,
  type WebsiteResourceCreate,
} from '../WebsiteBuilder.types'

export const createResourceHandler = async (
  createData: WebsiteResourceCreate
): Promise<WebsiteResource> => {
  const { brandId, path, title, sections } = createData

  const [brand, funnel, page, nav, theme] = await Promise.all([
    OlympusClient.brandsV0.brand.getBrand({
      params: {
        brandId,
      },
    }),
    OlympusClient.funnel.v1.brands.brand.getFunnel({
      params: {
        brandId,
      },
    }),
    OlympusClient.funnel.v1.pages.createPage({
      body: {
        brandId,
        path,
        sections,
        title,
      },
    }),
    OlympusClient.dashboard.v1.brands.brand.website.getNavItems({
      params: {
        brandId,
      },
    }),
    OlympusClient.brandsV0.brand.theme.getBrandTheme({
      params: {
        brandId,
      },
    }),
  ])

  return {
    ...page,
    brand,
    funnel,
    nav,
    theme,
  }
}
